module.exports = __webpack_public_path__ + "05_long_black.b73fe7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_long_black.png
// module id = 6T6+
// module chunks = 0